import { Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import Layout from "../components/layout/Layout";
import Login from "../pages/Login";
import Users from "../pages/Users/Users";
import Roles from "../pages/Roles/Roles";
import Teams from "../pages/Teams/Teams";
import useAuth from "../hooks/useAuth";
import Leads from "../pages/Leads/Leads";
import LeadDetailsWrapper from "../pages/[id]";
import Settings from "../pages/Settings/Settings";
import LeadsLayout from "../pages/Leads/LeadsLayout";
import NotFound from "../pages/404";
import ServerError from "../pages/500";
import ChatUI from "../pages/Chat/Chat";
import TicketsChatUI from "../pages/Tickets/Ticket";
import Reports_v2 from "../pages/Reports_v2";
import DetailedSourcePerformanceView from "../pages/Reports_v2/detailed";
import DetailedServicePerformanceView from "../pages/Reports_v2/services/DetailedServicePerformanceView";
import EmployeeReports from "../pages/Reports/EmployeeReports";
import BookingsReport from "../pages/Reports/BookingsReport";
import PaymentsReport from "../pages/Reports/PaymentsReport";
import ConversionsReport from "../pages/Reports/ConversionsReport";
import ServicesReport from "../pages/Reports/ServicesReport";
import ChatLayout from "../pages/Chat/ChatLayout";
import ChatTemplates from "../pages/Chat/Templates";
import CreateTemplate from "../pages/Chat/Templates/CreateTemplate";
import Dashboard from "../pages/Dashboard_v2/Dashboard";
import UrgentActionsPage from "../pages/Dashboard_v2/UrgentActionsPage";
import PendingTasksPage from "../pages/Dashboard_v2/PendingTasksPage";
import SystemAlertsPage from "../pages/Dashboard_v2/SystemAlertsPage";
// Commented out - Analytics is now disabled, kept only Chat module active
// import Analytics from "../pages/Chat/Analytics/Analytics";
import LeadScreen from "../pages/Leads_V2";
import DailyFollowups from "../pages/Leads_V2/Followup";
import Pipeline from "../pages/Leads_V2/Pipeline";
import CreateTemplateView from "../pages/Chat/Inbox/components/CreateTemplateView";
import AutomationRules from "../pages/Automation/AutomationRules";
import AIChatMasterControl from "../pages/MasterControl/AIChatMasterControl";
import CreateCampaign from "../pages/Campaign/CreateCampaign";
import CampaignList from "../pages/Campaign/CampaignList";
import KnowledgeBase from "../pages/KnowledgeBase/KnowledgeBase";
// import Profile from "../pages/Chat/Profile";

function PublicRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) return null;

  return user ? <Navigate to="/" replace /> : children;
}

export default function AppRoutes() {
  return (
    <Routes>
      <Route
        path="/login"
        element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        }
      />

      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <Layout>
              <Routes>
                <Route path="/" element={<LeadsLayout />}>
                  <Route index element={<Dashboard />} />
                  <Route path="dashboard" element={<Dashboard />} />
                  <Route
                    path="dashboard/urgent-actions"
                    element={<UrgentActionsPage />}
                  />
                  <Route
                    path="dashboard/pending-tasks"
                    element={<PendingTasksPage />}
                  />
                  <Route
                    path="dashboard/system-alerts"
                    element={<SystemAlertsPage />}
                  />
                </Route>

                <Route path="/leads" element={<LeadsLayout />}>
                  {/* <Route index element={<Leads />} /> */}
                  <Route index element={<LeadScreen />} />
                  <Route path="followups" element={<DailyFollowups />} />
                  <Route path=":id" element={<LeadDetailsWrapper />} />
                </Route>

                <Route path="/pipelines" element={<LeadsLayout />}>
                  <Route index element={<Pipeline />} />
                  <Route
                    path="pre-consultation"
                    element={<Pipeline pipelineType="pre-consult" />}
                  />
                  <Route
                    path="post-consultation"
                    element={<Pipeline pipelineType="post-consult" />}
                  />
                  <Route path=":id" element={<LeadDetailsWrapper />} />
                </Route>

                <Route path="/users" element={<Users />} />
                <Route path="/roles" element={<Roles />} />
                <Route path="/teams" element={<Teams />} />
                <Route path="/not-found" element={<NotFound />} />
                <Route path="/server-error" element={<ServerError />} />
                <Route path="*" element={<NotFound />} />

                {/* Automation */}
                <Route path="/automation/rules" element={<AutomationRules />} />

                {/* AI Master Control */}
                <Route path="/ai-master-control" element={<AIChatMasterControl />} />

                {/* Campaign */}
                <Route path="/campaign" element={<CampaignList />} />
                <Route path="/campaign/create" element={<CreateCampaign />} />
                <Route path="/campaign/edit/:id" element={<CreateCampaign />} />

                {/* Knowledge Base */}
                <Route path="/knowledge-base" element={<KnowledgeBase />} />

                <Route path="/ticket" element={<TicketsChatUI />} />
                <Route path="/settings">
                  <Route
                    index
                    element={<Navigate to="/settings/lead_features" replace />}
                  />
                  <Route path=":tab" element={<Settings />} />
                </Route>

                {/* Reports */}
                <Route path="/reports">
                  <Route index element={<Reports_v2 />} />
                  <Route
                    path="detailed-source-performance/:sourceName?"
                    element={<DetailedSourcePerformanceView />}
                  />
                  <Route
                    path="detailed-service-performance/:serviceName"
                    element={<DetailedServicePerformanceView />}
                  />
                </Route>

                {/* <Route path="contacts/:id" element={<Profile />} /> */}

                {/* Chat */}
                <Route path="/chat" element={<ChatLayout />}>
                  <Route
                    index
                    element={<Navigate to="/chat/inbox" replace />}
                  />

                  <Route path="inbox" element={<ChatUI />} />

                  <Route path="inbox/:id" element={<ChatUI />} />

                  <Route path="templates" element={<ChatTemplates />} />
                  <Route
                    path="templates/create"
                    element={<CreateTemplateView />}
                  />
                  {/* <Route path="analytics" element={<Analytics />} /> */}
                </Route>
              </Routes>
            </Layout>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}
